import React from 'react'
import styles from './UIGamePlayerInfoFooter.module.scss'
import clsx from 'clsx'
import {TranslationObject} from '@colonist/i18n'
import {Timer} from '../../../common/Timer/Timer'
import {T} from '@colonist/ui'
import {useTimerLowTime} from '../../../hooks/useTimerLowTime'
import {RED_TIMER_AND_TICKING_SOUND_THRESHOLD} from '@colonist/utils'

export interface UIGamePlayerInfoFooterProps {
    text: TranslationObject
    timeLeftInSeconds: number
    isLowTimeEnabled?: boolean
    hideTimer?: boolean
    hideText?: boolean
}

export const UIGamePlayerInfoFooter = ({
    text,
    timeLeftInSeconds,
    isLowTimeEnabled = true,
    hideTimer = false,
    hideText = false,
}: UIGamePlayerInfoFooterProps) => {
    const isRedAndTicking = isLowTimeEnabled && timeLeftInSeconds <= RED_TIMER_AND_TICKING_SOUND_THRESHOLD
    useTimerLowTime(timeLeftInSeconds, isRedAndTicking)

    return (
        <div className={styles.container}>
            {!hideText && <div className={styles.text}><T id={text} /></div>}
            {!hideTimer && <Timer className={clsx(styles.time, {[styles.lowTime]: isRedAndTicking})} timeLeftInSeconds={timeLeftInSeconds} />}
        </div>
    )
}
